import Swal from 'sweetalert2'

function Failure(config) {
  const title = config?.title ?? 'Error'
  const text = config?.text ?? ''
  const defaultConfig = {
    title: title,
    html: text,
    icon: 'error'
  }
  return Swal.fire(defaultConfig)
}

export { Failure }
